export const createRequiredLabels = (textToMakeRequired: string) => {
	return textToMakeRequired + '*';
};
